module.exports = __webpack_public_path__ + "img/surveying_technician_1_splash.b4221a04.jpg";